<template>
    <div class="main">
        <my_menu ></my_menu>

        <div class="content">
            <div>
                <my_project_data ref="my_project_data"></my_project_data>
            </div>
           
        </div>
    </div>


</template>

<script>
import my_menu from '@/component/menu/menu.vue'
import my_project_data from './component/my_project_data.vue'
import { http } from "@/utils/http.js";

export default {
    components: {
        my_menu,
        my_project_data
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            ak_list: [],
        }
    },

    mounted() {
        this.window_change()
        // this.get_ak_list()
    },

    methods: {


        click_add_ak() {
            var that = this
            this.$Modal.confirm({
                title: '更新AK(危险操作)',
                content: '添加后旧的AK会停用，可能会影响现有系统，请替换完原有AK后再继续，是否继续？',
                onOk: () => {
                    that.add_ak()
                },
                onCancel: () => {

                }
            })
        },

        //新增密钥
        add_ak() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/ak/add_ak", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_ak_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },



        //获取密钥列表
        get_ak_list() {
            var that = this
            var obj = {
                page: this.page
            }
            http("post", process.env.VUE_APP_HOST + "/ak/ak_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.ak_list = res.data.key_list

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.card_main {}

.card_field {
    width: 100px;
    flex-shrink: 0;
}

.card_line {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

}

.color{
    color:#0bbb05
}

.card {
    padding: 10px;
    border-bottom: 1px solid rgb(242, 242, 242)
}

.div_options {
    display: flex;
    justify-content: flex-end;
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    width: calc(100% - 180px);
    background-color: #fff;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
    padding: 10px;
}

.main {
    background: #f5f7f9;
    min-height: 100vh;
}
</style>